import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import { useAuth } from "../auth/AuthProvider";

function userInitials(name: string): string {
  return name.split(/\s+/).slice(0, 2).map((w) => w[0]?.toUpperCase() ?? "").join("");
}

export function Layout() {
  const { user, logout, isAdmin } = useAuth();

  return (
    <div style={{ display: "flex", minHeight: "100vh" }}>
      <aside className="sidebar">
        {/* Brand — same structure as Trusty Sieve */}
        <div className="sidebar-brand">
          <img src="/tinexta-logo-white.svg" alt="Tinexta InfoCert" className="brand-logo" />
          <div className="product-row">
            <img src="/trusty-icon-white.svg" alt="" />
            <span className="product-name">TrustyCERT</span>
          </div>
          <div className="product-sub">Firma Digitale Remota</div>
        </div>

        {/* Nav */}
        <nav className="sidebar-nav">
          {/* ── InfoCert TOP section ── */}
          <div className="nav-section">
            <div className="nav-section-label">
              <span className="material-symbols-outlined">verified</span>
              InfoCert TOP
            </div>
            <NavLink to="/" end className={({ isActive }) => `nav-item${isActive ? " active" : ""}`}>
              <span className="material-symbols-outlined">add_circle</span>
              <span>Nuovo Dossier</span>
            </NavLink>
            <NavLink to="/sessions" className={({ isActive }) => `nav-item${isActive ? " active" : ""}`}>
              <span className="material-symbols-outlined">history</span>
              <span>Sessioni di Firma</span>
            </NavLink>
          </div>

          {/* ── FEA section ── */}
          <div className="nav-section">
            <div className="nav-section-label">
              <span className="material-symbols-outlined">draw</span>
              FEA
            </div>
            <div className="nav-item-disabled">
              <span className="material-symbols-outlined">upload_file</span>
              <span>Invio Documento</span>
              <span className="badge-soon">Presto</span>
            </div>
            <div className="nav-item-disabled">
              <span className="material-symbols-outlined">folder_open</span>
              <span>Pratiche FEA</span>
              <span className="badge-soon">Presto</span>
            </div>
          </div>

          {/* ── Admin section — visible only to admins ── */}
          {isAdmin && (
            <div className="nav-section">
              <div className="nav-section-label">
                <span className="material-symbols-outlined">admin_panel_settings</span>
                Amministrazione
              </div>
              <NavLink
                to="/providers"
                className={({ isActive }) => `nav-item${isActive ? " active" : ""}`}
              >
                <span className="material-symbols-outlined">cable</span>
                <span>Provider</span>
              </NavLink>
            </div>
          )}
        </nav>

        {/* User — same structure as Trusty Sieve */}
        {user && (
          <div className="sidebar-user">
            <div style={{ display: "flex", alignItems: "center" }}>
              <span className="user-avatar">{userInitials(user.name)}</span>
              <div style={{ minWidth: 0 }}>
                <div className="user-name truncate">{user.name}</div>
                <div className="user-role">{user.email}</div>
              </div>
            </div>
            <button className="btn-logout" onClick={logout}>Esci</button>
          </div>
        )}
      </aside>

      <main style={{
        marginLeft: "var(--sidebar-width)",
        flex: 1,
        padding: "var(--space-6)",
        maxWidth: "var(--content-max-width)",
      }}>
        <Outlet />
      </main>
    </div>
  );
}
